import { useEffect, useState } from 'react';
import {
  DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton,
  GridToolbarDensitySelector, GridToolbarExportContainer, GridCsvExportMenuItem, esES,
  GridPrintExportMenuItem, gridClasses
} from '@mui/x-data-grid';
import jwt_decode from "jwt-decode";
import es from "date-fns/locale/es";
import { Alert, Box, Button, Card, CardContent, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';

import OpenInNewTwoToneIcon from '@mui/icons-material/OpenInNewTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
const csvOptions = { utf8WithBom: true };
const printOptions = {
  hideFooter: true,
  hideToolbar: true,
}

const opcionesTipo = ['contrato', 'serviciosProfesionales']

const CustomExportButton = (props) => (
  <GridToolbarExportContainer {...props}>
    <GridCsvExportMenuItem options={csvOptions} />
    <GridPrintExportMenuItem options={printOptions} />
  </GridToolbarExportContainer>
);

const colocarNombre = (ruta) => {
  if (!ruta || ruta === '')
    return ''
  const indice = Number(ruta.indexOf("factura")) + 9
  return ruta.slice(indice)

}

const colocarNombreOficio = (ruta) => {
  if (!ruta || ruta === '')
    return ''
  const indice = Number(ruta.indexOf("oficio_"))
  return ruta.slice(indice)
}

const colocarNombreDocumento = (ruta) => {
  const indice = Number(ruta.indexOf("documentosSolicitud")) + 20
  return ruta.slice(indice)

}

const columns = [
  { id: 'ruta', label: 'Documento', width: 150, align: 'center' },
  { id: 'descripcion', label: 'Descripción', width: 150, align: 'justify' },
];

const CustomToolbar = (props) => (
  <GridToolbarContainer {...props}>
    <GridToolbarColumnsButton />
    <GridToolbarFilterButton />
    <GridToolbarDensitySelector />
    <CustomExportButton />
  </GridToolbarContainer>
);

export default function PagosCajaListado() {
  const [data, setData] = useState({ columns: [], rows: [] })
  const [pageSize, setPageSize] = useState(15)
  const [openContrato, setOpenContrato] = useState(false)
  const [solicitud, setSolicitud] = useState(null)
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [openPago, setOpenPago] = useState(false);
  const [mensajePago, setMensajePago] = useState('');
  const [asistentes, setAsistentes] = useState([])

  const [severity, setSeverity] = useState('error')
  const [severityPago, setSeverityPago] = useState('error')
  const [contrato, setContrato] = useState(null)
  const [servicio, setServicio] = useState(null)
  const [errorFecha, setErrorFecha] = useState(false)
  const [fechaPago, setFechaPago] = useState(null)
  const [expanded, setExpanded] = useState({});

  // Función para cambiar el estado de expansión de un acordeón específico
  const handleChange = (id) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [id]: isExpanded, // Solo actualizamos el acordeón con el id correspondiente
    }));
  };

  const token = sessionStorage.getItem('token')
  const decoded = jwt_decode(token);
  
  const obtenerReglas = () => {
    let reglas
    const perfilElegido = sessionStorage.getItem('perfilElegido')
    switch (perfilElegido) {
      case 'asistente':
        reglas = decoded.rulesAsistente
        break
      case 'investigador':
        reglas = decoded.rulesJefaturaArea
        break
      case 'coordinacion':
        reglas = decoded.rulesCoordinacion
        break
      case 'jefe':
        reglas = decoded.rulesJefatura
        break
      case 'administracion':
        reglas = decoded.rulesAdministracionProyecto
        break
      default:
        break
    }
    return reglas
  }

  let reglas = decoded.rules

  if (!reglas)
    reglas = obtenerReglas()

  const cargarDatosTabla = async () => {
    const url = `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/tipoCaja`;
    const resSolicitudes = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      }
    })

    let solicitudes = await resSolicitudes.json()
    //console.log(`PLAN ${JSON.stringify(plan)}`)

    //console.log(`responsables ${JSON.stringify(responsables)}`)
    const buscadorResponsables = []



    const datos = {
      columns: [{ field: "folio", width: 180, headerName: "Folio", hide: false, sortable: true, filterable: true },
      {
        field: "tipo", width: 100, headerName: "Tipo", hide: false, sortable: true, filterable: true, type: "singleSelect", valueOptions: opcionesTipo,
        valueFormatter: ({ value }) => {
          return (value === 'serviciosProfesionales' ? 'Pago único de servicios profesionales'
            : value === 'contrato' ? 'Contrato'
              : 'Indefinido')
        },
        renderCell: ({ value, row }) => (value === 'serviciosProfesionales' ? 'Pago único de servicios profesionales'
          : value === 'contrato' ? 'Contrato'
            : 'Indefinido')
      },
      { field: "solicitante", width: 150, headerName: "Solicitante", hide: false, sortable: true, filterable: true, type: "singleSelect", "valueOptions": buscadorResponsables },
      {
        field: "monto", width: 150, headerName: "Monto", headerAlign: 'left', hide: false, sortable: false, filterable: true, type: "number", valueFormatter: ({ value }) => (value ? value.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) : 'Sin definir'),
        renderCell: ({ value }) => (value ? value.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) : 'Sin definir')
      },
      {
        field: "documentoSolicituds", width: 200, headerName: "Documentos", disableExport: true, filterable: false, hide: false, renderCell: ({ value, row }) => (
          <span style={{ wordBreak: 'break-word', width: '100%' }}>
            {value.map((documento) => {
              return (
                documento.tipo === 'oficioSolicitud' ? (
                  <Button key={documento.id}
                    size='small'
                    variant='contained'
                    style={{ marginTop: 20, backgroundColor: "darkgreen", color: 'white', width: '80%' }}
                    onClick={async () => { await desplegarDocumentoPDF(documento) }}
                  >
                    <span style={{ wordBreak: 'break-all' }}>
                      {colocarNombreOficio(documento.ruta)} <PictureAsPdfTwoToneIcon />
                    </span>
                  </Button>
                ) : null
              );
            })}
            {
              <>
                {row.tipo === 'serviciosProfesionales' ? <><br /><Button variant='contained' color='primary' style={{ margin: 4 }} size='small' onClick={() => { setSolicitud(row); setServicio(row.serviciosProfesionales[0]); setOpenPago(false); setErrorFecha(false); setFechaPago(null); setOpenContrato(true) }}>Capturar fecha de pago <OpenInNewTwoToneIcon></OpenInNewTwoToneIcon></Button></>
                  : row.tipo === 'contrato' ? <><br /><Button variant='contained' color='primary' style={{ margin: 4 }} size='small' onClick={() => { setSolicitud(row); setContrato(row.contratos[0]); setOpenPago(false); setErrorFecha(false); setFechaPago(null); setOpenContrato(true) }}>Capturar fecha de pago <OpenInNewTwoToneIcon></OpenInNewTwoToneIcon></Button></>
                    : <></>}
              </>}
          </span >)

      },
      {
        field: "createdAt", width: 150, headerName: "Fecha", hide: false, sortable: true, filterable: true, type: "date", valueFormatter: ({ value }) => (new Date(value)).toLocaleDateString('es-MX', { day: "2-digit", month: "short", year: "numeric" }), renderCell: ({ value }) => (
          (new Date(value)).toLocaleDateString('es-MX', { day: "2-digit", month: "short", year: "numeric" })
        )
      },
      ], rows: solicitudes

    }
    setData(datos)
  }

  const validarFecha = (fechaPago) => {
    //console.log(fechaPago)
    if (fechaPago)
      return true
    else {
      setSeverityPago('error')
      setOpenPago(true)
      setErrorFecha(true)
      setMensajePago('Favor de indicar la fecha')
      return false
    }
  }

  const handleContrato = async (pago) => {
    const esValido = validarFecha(fechaPago)
    if (!esValido)
      return
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/guardarFecha`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      },
      body: JSON.stringify({
        id: pago.id,
        fecha: fechaPago
      })
    })
    if (res.status === 200) {
      setSeverityPago('success')
      cargarDatosTabla()
    }
    else
      setSeverityPago('error')
    const data = await res.json()

    if (data.message) {
      setOpenPago(true)
      setMensajePago(data.message)
      return
    }
  };

  const handleServicio = async (pago) => {
    const esValido = validarFecha(fechaPago)
    if (!esValido)
      return
    const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/serviciosProf/guardarFecha`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil')
      },
      body: JSON.stringify({
        id: pago.id,
        fecha: fechaPago
      })
    })
    if (res.status === 200) {
      setSeverityPago('success')
      cargarDatosTabla()
    }
    else
      setSeverityPago('error')
    const data = await res.json()

    if (data.message) {
      setOpenPago(true)
      setMensajePago(data.message)
      return
    }
  };

  /*const mostrarDocumento = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "ruta": value,
        "tipo": tipo
      }
    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.log(err);
      });
  }*/

  const desplegarDocumentoPDF = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/mostrarDocumentoPDF`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "documento": JSON.stringify(value),
        "tipo": tipo
      },

    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.error(err);
      });
  }

  const [filterModel, setFilterModel] = useState({ items: [{ columnField: "estado", operatorValue: "not", id: 13752, value: "cancelada" }] });


  useEffect(() => {
    (async () => {
      await cargarDatosTabla()

      const resAsistentes = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/leerAsistentesEntidad/${sessionStorage.getItem('idEntidad')}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": sessionStorage.getItem('token'),
          "perfil": sessionStorage.getItem('perfil')
        }
      })

      const asistentesLeidas = await resAsistentes.json()

      setAsistentes(asistentesLeidas)
      setFilterModel({
        items: [{ columnField: 'estado', operatorValue: 'isAnyOf', value: ["registrada", "autorizada", "ajustesJefe", "ajustesAsistente", "firmaAutografa", "enRevision", "registrarGastos", "devolucionCaja"] }],
      })

    })();
    // eslint-disable-next-line
  }, [solicitud]
  )

  return (
    <div style={{ display: 'flex', marginTop: '50px' }}>
      <Card style={{ height: '100%', width: '100%' }}>
        <CardHeader title='Solicitudes de servicio'></CardHeader>
        <CardContent sx={{ height: 700 }}>
          <DataGrid {...data} pageSize={pageSize} getRowHeight={() => 'auto'} getRowId={(row) => row.id} sx={{
            [`& .${gridClasses.cell}`]: {
              py: 1,
            },
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
          }}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}

            filterModel={filterModel}
            onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}

          >



          </DataGrid>
        </CardContent>
      </Card>

      <Dialog open={openContrato} fullWidth={true} maxWidth='lg'>
        <DialogTitle>Pago {solicitud ? solicitud.folio : ''}</DialogTitle>
        <DialogContent style={{ backgroundColor: '#FFFEED', padding: 20 }}>
          <DialogContentText>
          </DialogContentText>
          {solicitud && solicitud.tipo === 'contrato' && contrato ? contrato.pagoContratos.map((pago) => {
            return (
              <Accordion expanded={expanded[pago.id]} id={pago.id} onChange={handleChange(pago.id)}>
                <AccordionSummary
                  expandIcon={<Button style={{ textTransform: 'none' }}>
                    {expanded[pago.id] ? '' : 'Más información'}{expanded[pago.id]}
                    <ExpandMoreIcon />
                  </Button>} id={pago.id}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                        <DatePicker required label="Fecha de Pago"
                          value={fechaPago}
                          onChange={(newValue) => {
                            setFechaPago(newValue)
                            setErrorFecha(false)
                            setMensajePago('')
                            setOpenPago(false)
                          }}
                          renderInput={(params) => <TextField {...params} name="fecha" id="fecha" required error={errorFecha} focused variant='outlined' style={{ width: '100%' }} />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}><Button color='primary' variant='contained' size='small' onClick={async (event) => { await handleContrato(pago) }} sx={{ wordBreak: 'break-all', textTransform: 'none' }}>Guardar</Button></Grid>
                    <Grid item xs={12} sm={4}></Grid>
                    <Grid item xs={12}>
                      <Box sx={{ width: '100%' }}>
                        <Collapse in={openPago}>
                          <Alert severity={severityPago}
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={(event) => {
                                  setOpenPago(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                            style={{ marginTop: 30 }}
                          >
                            {mensajePago}
                          </Alert>
                        </Collapse>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container justifyContent='stretch' spacing={5} key={pago.id} style={{ marginTop: 5 }}>
                    {pago.descripcion ? <> <Grid item xs={2}>Descripción:</Grid>
                      <Grid item xs={10}>{pago.descripcion}</Grid></> : <></>}
                    {pago.observaciones ? <> <Grid item xs={2}>Observaciones:</Grid>
                      <Grid item xs={10}>{pago.observaciones}</Grid></> : <></>}
                    {pago.rutaPDF ?
                      <>
                        <Grid item xs={2}>Factura:</Grid>
                        <Grid item xs={5}><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(pago) }} sx={{ wordBreak: 'break-all', textTransform: 'none' }}>{colocarNombre(pago.rutaPDF)}</Button></Grid>
                        {pago.rutaXML ?
                          <Grid item xs={5}><Button color='success' size='small' sx={{ wordBreak: 'break-all', textTransform: 'none' }} href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(pago.rutaXML)}`} download={colocarNombre(pago.rutaXML)}>{colocarNombre(pago.rutaXML)}</Button></Grid>
                          : <></>}
                      </> : <></>}
                    {pago.documentosAnexos ?
                      <Grid item xs={12}><Button color='success' size='small' href={`${pago.documentosAnexos}`} target='_blank'>Documentos anexos en Drive</Button></Grid>
                      : <></>}

                    {pago.documentoPagos && pago.documentoPagos.length > 0 ? <Grid item xs={12} md={12} spacing={2}>


                      <Box
                        id="category-c"
                        sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                      >
                        <TableContainer sx={{ mb: 5, display: !pago.documentoPagos || pago.documentoPagos.length === 0 ? 'none' : 'block', width: '90%' }}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow key='encabezado'>
                                <TableCell key='ninguna' align="center" colSpan={3}>
                                  Documentos adjuntos registrados
                                </TableCell>
                              </TableRow>
                              <TableRow key='encabezado2'>
                                {columns.map((column) => (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ top: 57, minWidth: column.minWidth }}
                                  >
                                    {column.label}
                                  </TableCell>

                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {
                                pago.documentoPagos && pago.documentoPagos.length > 0 ? pago.documentoPagos
                                  .map((row, index) => {
                                    return (
                                      <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                                        {
                                          columns.map((column) => {
                                            const value = row[column.id];

                                            // total=Number(total)+Number(value)
                                            // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                                            return (
                                              <TableCell key={column.id} align={column.align} style={{ wordBreak: 'break-word' }}>
                                                {column.id === 'ruta' ? <Button size='small' variant="text" style={{ marginTop: 20, color: 'darkgreen', width: '100%', textTransform: "none" }} onClick={async () => { await desplegarDocumentoPDF(row) }}><span style={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}>{colocarNombreDocumento(value)}</span></Button> : value}
                                              </TableCell>
                                            );
                                          })}

                                      </TableRow>
                                    );
                                  }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                  <TableCell align='center' colSpan={3}>
                                    No hay documentos registrados
                                  </TableCell>

                                </TableRow>}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>

                    </Grid> : <></>}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )
          }) : <></>}

          {solicitud && solicitud.tipo === 'serviciosProfesionales' && solicitud.serviciosProfesionales[0] ? solicitud.serviciosProfesionales.map((pago) => {
            return (
              <Accordion expanded={expanded[pago.id]} id={pago.id} onChange={handleChange(pago.id)}>
                <AccordionSummary
                  expandIcon={<Button style={{ textTransform: 'none' }}>
                    {expanded[pago.id] ? '' : 'Más información'}{expanded[pago.id]}
                    <ExpandMoreIcon />
                  </Button>} id={pago.id}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                        <DatePicker required label="Fecha de Pago"
                          value={fechaPago}
                          onChange={(newValue) => {
                            setFechaPago(newValue)
                            setErrorFecha(false)
                            setMensajePago('')
                            setOpenPago(false)
                          }}
                          renderInput={(params) => <TextField {...params} name="fecha" id="fecha" required error={errorFecha} focused variant='outlined' style={{ width: '100%' }} />}
                        />
                      </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}><Button color='primary' variant='contained' size='small' onClick={async (event) => { await handleServicio(pago) }} sx={{ wordBreak: 'break-all', textTransform: 'none' }}>Guardar</Button></Grid>
                    <Grid item xs={12} sm={4}></Grid>
                    <Grid item xs={12}>
                      <Box sx={{ width: '100%' }}>
                        <Collapse in={openPago}>
                          <Alert severity={severityPago}
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={(event) => {
                                  setOpenPago(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                            style={{ marginTop: 30 }}
                          >
                            {mensajePago}
                          </Alert>
                        </Collapse>
                      </Box>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container justifyContent='stretch' spacing={5} key={pago.id} style={{ marginTop: 5 }}>
                    {pago.descripcion ? <> <Grid item xs={2}>Justificación:</Grid>
                      <Grid item xs={10}>{pago.justificacion}</Grid></> : <></>}
                    {pago.observaciones ? <> <Grid item xs={2}>Observaciones:</Grid>
                      <Grid item xs={10}>{pago.observaciones}</Grid></> : <></>}
                    {pago.rutaPDF ?
                      <>
                        <Grid item xs={2}>Factura:</Grid>
                        <Grid item xs={5}><Button color='success' size='small' onClick={async () => { await desplegarDocumentoPDF(pago) }} sx={{ wordBreak: 'break-all', textTransform: 'none' }}>{colocarNombre(pago.rutaPDF)}</Button></Grid>
                        {pago.rutaXML ?
                          <Grid item xs={5}><Button color='success' size='small' sx={{ wordBreak: 'break-all', textTransform: 'none' }} href={`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/seguimientoSolicitudes/descargarDocumentoPDF/${colocarNombre(pago.rutaXML)}`} download={colocarNombre(pago.rutaXML)}>{colocarNombre(pago.rutaXML)}</Button></Grid>
                          : <></>}
                      </> : <></>}


                    {pago.documentoSolicituds && pago.documentoSolicituds.length > 0 ? <Grid item xs={12} md={12} spacing={2}>


                      <Box
                        id="category-c"
                        sx={{ fontSize: '12px', textTransform: 'none', fontWeight: 700, mb: 2 }}
                      >
                        <TableContainer sx={{ mb: 5, display: !pago.documentoPagos || pago.documentoPagos.length === 0 ? 'none' : 'block', width: '90%' }}>
                          <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                              <TableRow key='encabezado'>
                                <TableCell key='ninguna' align="center" colSpan={3}>
                                  Documentos adjuntos registrados
                                </TableCell>
                              </TableRow>
                              <TableRow key='encabezado2'>
                                {columns.map((column) => (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ top: 57, minWidth: column.minWidth }}
                                  >
                                    {column.label}
                                  </TableCell>

                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {
                                pago.documentoSolicituds && pago.documentoSolicituds.length > 0 ? pago.documentoSolicituds
                                  .map((row, index) => {
                                    return (
                                      <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                                        {
                                          columns.map((column) => {
                                            const value = row[column.id];

                                            // total=Number(total)+Number(value)
                                            // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                                            return (
                                              <TableCell key={column.id} align={column.align} style={{ wordBreak: 'break-word' }}>
                                                {column.id === 'ruta' ? <Button size='small' variant="text" style={{ marginTop: 20, color: 'darkgreen', width: '100%', textTransform: "none" }} onClick={async () => { await desplegarDocumentoPDF(row) }}><span style={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}>{colocarNombreDocumento(value)}</span></Button> : value}
                                              </TableCell>
                                            );
                                          })}

                                      </TableRow>
                                    );
                                  }) : <TableRow hover role="checkbox" tabIndex={-1} >

                                  <TableCell align='center' colSpan={3}>
                                    No hay documentos registrados
                                  </TableCell>

                                </TableRow>}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>

                    </Grid> : <></>}
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )
          }) : <></>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenContrato(false) }}>Cerrar</Button>
        </DialogActions>

        <Box sx={{ width: '100%' }}>
          <Collapse in={open}>
            <Alert severity={severity}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              style={{ marginTop: 30 }}
            >
              {mensaje}
            </Alert>
          </Collapse>
        </Box>
      </Dialog>
    </div>
  );
}